<template>
    <tr class="clickable-row">
        <td><a href="" @click.prevent.stop>{{entry.patient.code_external}}</a></td>
      <td><a href="" @click.prevent.stop>{{entry.patient.initial_first_name}}. {{entry.patient.initial_last_name}}.</a></td>
      <td><a href="" @click.prevent.stop>{{entry.patient.birthday}}</a></td>
        <td><a href="" @click.prevent.stop>{{getLongDateFromISO(entry.created_date)}}</a></td>
      <td v-if="isFollowUpTable"><a href="" @click.prevent.stop>{{entry.rank_follow_up}}/{{entry.follow_up_ids.length}}</a></td>
      <td><a href="" @click.prevent.stop>{{entry.note}}</a></td>
        <td class="text-right">
            <a class="btn btn-default" @click.prevent.stop="$emit('open-entry', entry.id)">
                <i class="las la-eye"></i>Mostra record
            </a>
            <a class="btn btn-danger"  v-show="deletePermission" @click.prevent.stop="$emit('open-delete', entry.id)">
                <i class="la la-trash"></i>
            </a>
        </td>
    </tr>
</template>

<script>
    import {Utils} from "../../common/utils";

    export default {
        name: "EntryRow",
        props: {
            entry: {
                type: Object,
                require: true
            },
          isFollowUpTable: {
            type: Boolean,
            default: false
          },
            deletePermission: Boolean
        },
        methods: {
            getLongDateFromISO(date){
                return Utils.getLongDateFromISO(date)
            }
        }
    };
</script>
